<template>
  <v-app>
    <v-main>
      <ImagesViewer />
      <v-container fluid class="lower-half">
        <v-row
          align="center"
          justify="center"
          class="fill-height"
        >
          <v-col cols="12" md="6">
            <div class="form-card elevation-2 pa-4">
              <!-- Centered Heading -->
              <v-row justify="center">
                <v-col cols="12">
                  <v-h1 class="text-h6 text-md-h5 text-lg-h4 text-center">
                    {{ $t('chaletDetail.contactus') }}
                  </v-h1>
                </v-col>
              </v-row>

              <!-- Centered Images -->
              <v-row justify="center" class="mt-4">
                <v-col cols="auto">
                  <v-img
                    src="images/whatsapp2.png"
                    height="80px"
                    width="80px"
                    class="cursor-pointer"
                    @click="gowhatsappToLink"
                  ></v-img>
                </v-col>
                <v-col cols="auto">
                  <v-img
                    src="images/instagram.png"
                    height="80px"
                    width="80px"
                    class="cursor-pointer"
                    @click="goinstagramToLink"
                  ></v-img>
                </v-col>
                <v-col cols="auto">
                  <v-img
                    src="images/googlemaps.png"
                    height="60px"
                    width="80px"
                    class="cursor-pointer"
                    @click="goGoogleMapsToLink"
                  ></v-img>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import ImagesViewer from '@/components/ImagesViewer.vue';

export default {
  components: { ImagesViewer },
  methods: {
    gowhatsappToLink() {
      window.open('https://wa.me/96894648300', '_blank');
    },
    goinstagramToLink() {
      window.open('https://www.instagram.com/lovinachalet', '_blank');
    },
    goGoogleMapsToLink() {
      window.open('https://maps.app.goo.gl/4hJ9kiqjqAor43bWA?g_st=iw', '_blank');
    },
  },
}
</script>

<style scoped>
/* LOWER HALF - Deep blue to midnight gradient */
.lower-half {
  background: linear-gradient(to right, #546E7A, #78909C);
  min-height: 30vh;
  color: #e3e3e3; 
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-card {
  background-color: #9E9E9E;
  border-radius: 20px;
  padding: 20px;
  width: 100%;
  max-width: 1000px; /* Adjust as needed */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cursor-pointer {
  cursor: pointer;
}

.mt-4 {
  margin-top: 1.5rem; /* Vuetify's spacing scale: mt-4 = 1.5rem */
}
</style>
